import adminReducer from "@/components/data/admin/ducks/reducer"
import userReducer from "@/components/data/ducks/reducer"
import internalReducer from "@/components/data/internal/ducks/reducer"
import volunteerReducer from "@/components/data/volunteer/ducks/reducer"
import { combineReducers } from "@reduxjs/toolkit"

const dataReducer = combineReducers({
  admin: adminReducer,
  internal: internalReducer,
  volunteer: volunteerReducer,
  user: userReducer,
})

export default dataReducer
